export const getWindowLocation = (useParentLocation = false) => {
  // If requested and we're within an iframe, use parent location
  if (useParentLocation) {
    try {
      if (window.self !== window.top && window.parent) {
        const parentLoc = window.parent.location;
        // Attempt to access a property to trigger cross-origin exception if blocked
        void parentLoc.pathname;
        return parentLoc;
      }
    } catch (e) {
      // Cross-origin access blocked - return null to indicate unavailable
      return null;
    }
  }
  return window.location;
};